import React from 'react'
import Footer from './Layouts/Footer'
import Header from './Layouts/Header'

const DashboardLayout = ({ children }) => {

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
        <main className="flex flex-1 m-h-full w-full">
            <div className="flex flex-col h-full w-full">
              {children}            
            </div>
        </main>
      <Footer />
    </div>
  )
}

export default DashboardLayout
